/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CategoryCountResponse {
    getFixupPrototypeFunction() { return CategoryCountResponse.fixupPrototype; }

    static newInstance(model: Partial<CategoryCountResponse>): CategoryCountResponse {
        let obj = Object.assign(new CategoryCountResponse(), model);
        CategoryCountResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CategoryCountResponse>): CategoryCountResponse {
        if (!model) return null;
        return CategoryCountResponse.newInstance(<CategoryCountResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CategoryCountResponse) {
        if (!obj) return;

        models.CategoryCountResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CategoryCountResponse): boolean {
        Object.setPrototypeOf(obj, CategoryCountResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.category_details) {
            models.CategoryCountResponseModelList.fixupPrototype(this.category_details);
        }
    }

    /**
     * Inventory category count details
     */
    category_details: models.CategoryCountResponseModelList;

    /**
     * Inventory resource count details
     */
    resource_details: any;

}
